import _ from "lodash"

import Model from "../../model"
import { Idea, ID, ideaWidth, ideaHeight } from "../../types"
import Command, { CommandName } from "../command"
import DeleteIdeasCommand from "./delete_ideas_command"

export type CreateIdeaCommandState = {
  id: ID
  idea: Idea
  inProjectsWithIndex?: [ID, number][]
  isGoalForSources?: ID[]
}

export default class CreateIdeaCommand extends Command {
  name: CommandName = "create-idea"
  state: CreateIdeaCommandState

  constructor(state: CreateIdeaCommandState) {
    super()
    this.state = state
  }

  // Possible conflicts:
  //   - another idea has been created at or moved into this location (Resolve)
  resolveConflicts(model: Model): CreateIdeaCommandState | null {
    const ideaAlreadyInThisSpot = model.getIdeaAt(this.state.idea.location)
    if (ideaAlreadyInThisSpot) {
      const newLocation = model.getNearestAvailableLocationIgnoring(
        this.state.idea.location,
        ideaWidth(this.state.idea),
        ideaHeight(this.state.idea),
        []
      )
      return {
        ..._.cloneDeep(this.state),
        idea: { ..._.cloneDeep(this.state.idea), location: newLocation },
      }
    } else {
      return this.state
    }
  }

  local(model: Model): any {
    model.createIdea(
      this.state.id,
      this.state.idea,
      this.state.inProjectsWithIndex,
      this.state.isGoalForSources
    )
  }

  undo(): Command[] {
    return [new DeleteIdeasCommand({ ids: [this.state.id] })]
  }
}
